import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/App-Context";

import axios from "axios";

const EntranceVerification = () => {
  /////////// sign up

  const auth = useContext(AuthContext);

  const navigate = useNavigate();
  // In handleSubmit, after success:

  //////// post request , axios

  ///
  ///
  ///
  ///

  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
    username: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  // Handle input changes
  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      // Make POST request to your API endpoint
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/lgn-funcs/userSignup`,
        {
          email: credentials.email,
          password: credentials.password,
          username: credentials.username,
        },
        { withCredentials: true }
      );

      //console.log("here's the data vvv");
      // console.log(response.data);
      //console.log("here's the data .data.data.loginVar. vvv");
      // console.log(response.data.data.loginVar.username);
      //console.log("working code");
      // console.log("here's the data .data.loginVar. vvvv");
      // console.log(response.data.loginVar.username);

      // Handle successful response (e.g., store token, redirect)
      //setSuccess("Login successful!");
      auth.login(response.data.data.loginVar.username);
      // console.log("Response:", response.data); // Example: { token: 'xyz' }
      // Optional: Store token in localStorage or redirect
      // localStorage.setItem("token", response.data.data.token);
      // Redirect to dashboard or protected route
      // window.location.href = '/dashboard';
      navigate(`/TempleGrid/${response.data.data.loginVar.username}`);
      //console.log("function complete");
    } catch (err) {
      // Handle errors (e.g., invalid credentials, server error)
      setError(
        err.response?.data?.message || "Login failed. Please try again."
      );
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  ///////

  // console.log(response.status);
  // console.log(response.statusText);
  // console.log(response.headers);
  // console.log(response.config);

  return (
    <div className="door">
      <div className="door-frame">
        <div className="door-molding">
          <form onSubmit={handleSubmit}>
            <div className="door-molding-crown">email</div>
            <div>
              <input
                type="email"
                name="email"
                id="email"
                value={credentials.email}
                onChange={handleChange}
                required
                placeholder="Enter your email"
                className="door-molding-etching"
              />
            </div>
            <div className="door-molding-crown">username</div>
            <div>
              <input
                maxLength={17}
                type="username"
                name="username"
                id="username"
                onChange={handleChange}
                required
                value={credentials.username}
                className="door-molding-etching"
              />
            </div>
            {/* <div className="door-molding-crown">password</div>
            <div>
              <input className="door-molding-etching" />
            </div> */}
            <div className="door-molding-crown">password</div>
            <div>
              <input
                type="password"
                name="password"
                id="password"
                value={credentials.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                className="door-molding-etching"
              />
            </div>
            <div className="door-handle-enter">
              <button className="door-handle-enter-text">
                {/* <button type="submit" disabled={loading}>
                  signup
                  {loading ? "Logging in..." : "Login"}
                </button> */}
                signup
              </button>
            </div>
            <div className="door-handle-navigate-login">
              <Link to="/login">login</Link>
            </div>
            {/* <div className="door-handle-navigate-forgotpw">
              <Link to="/forgotpassword">forgot password</Link>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default EntranceVerification;
